<template>
  <v-flex xs12 sm6 d-flex>
    <v-select
      :items="validStatus"
      label="Status"
      v-model="status"
      item-text="title"
      item-value="business"
      return-object
      prepend-icon="label"
    ></v-select>
  </v-flex>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import * as business from '@/helpers/business';

export default {
  name: 'Status',
  computed: {
    status: {
      get() {
        return this.model;
      },
      set(newStatus) {
        this.updateStatus(newStatus.business);
        this.model;
      },
    },
    ...mapGetters({
      model: 'deposits/status',
    }),
  },
  methods: {
    ...mapActions({
      updateStatus: 'deposits/updateStatus',
    }),
  },
  data: () => ({
    validStatus: [
      { title: 'Todos', business: '' },
      { title: 'Agendado', business: business.DEPOSIT_STATUS_SCHEDULED },
      { title: 'Processando', business: business.DEPOSIT_STATUS_PROCESSING },
      { title: 'Cancelado', business: business.DEPOSIT_STATUS_CANCELLED },
      { title: 'Compensado', business: business.DEPOSIT_STATUS_COMPLETED },
      { title: 'Falha', business: business.DEPOSIT_STATUS_FAILED },
      { title: 'Abatido', business: business.DEPOSIT_STATUS_DOWNED },
      { title: 'Antecipado', business: business.DEPOSIT_STATUS_ANTECIPATED },
    ],
  }),
};
</script>
